<template lang="html">
  <div class="main">
    <div class="name">
      <div class="title">{{message.Sl189}}</div>
    </div>
    <div class="box">
      <div class="title medium">{{message.Sl217}}</div>
      <comp-notice ref="notice"></comp-notice>
      <div class="title medium">{{message.Sl216}}</div>
      <comp-emails ref="emails"></comp-emails>
    </div>
  </div>
</template>

<script>
import CompNotice from './notification/notice.vue'
import CompEmails from './notification/emails.vue'
export default {
  beforeRouteLeave (to, from, next) {
    if (this.$refs.notice.active || this.$refs.emails.active) {
      this.$confirm(this.$lang.ui.notice.l141, this.$lang.ui.system.l133, {
        confirmButtonText: this.$lang.ui.form.l127,
        cancelButtonText: this.$lang.ui.form.l101,
        type: 'warning'
      }).then(() => {
        next()
      }).catch(() => {
        next(false)
      })
    } else {
      next()
    }
  },
  components: {
    CompNotice,
    CompEmails
  },
  data () {
    return {
      message: {
        Sl189: this.$lang.ui.system.l189,
        Sl216: this.$lang.ui.system.l216,
        Sl217: this.$lang.ui.system.l217
      },
      scrollSettings: {
        maxScrollbarLength: 0
      }
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped lang="css">
.main {
  width: 100%;
  min-width: 710px;
  padding-bottom: 60px;
}
.name {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}
.left {
  float: left;
  margin: 11px;
  margin-right: 18px;
  cursor: pointer;
}
.title {
  display: block;
  height: 100%;
  line-height: 50px;
  float: left;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 600;
}
.box {
  width: 100%;
  height: 100%;
}
.ticket-more {
  width: 100%;
  padding: 20px;
}
.cell {
  background-color: #fff;
  border-radius: 2px;
  padding: 30px 55px;
}
.bottom-button {
  text-align: right;
  width: 100%;
  padding: 25px;
}
.title.medium {
  display: block;
  height: auto;
  margin: 0 auto;
  font-size: 14px;
  float: none;
  padding-left: 20px;
}
</style>
